import { useEffect } from "react"
import {
  brazeInitialise,
  conditionsMetToTrackUser,
} from "@theconversation/shared-components/braze-tc"
import getConfig from "next/config"
import { nonProdLogger } from "@theconversation/shared-components/nonProdLogger"

export const BrazeConditionalLoader = () => {
  const publicConfig = getConfig().publicRuntimeConfig
  const sdkEndpoint = publicConfig.BRAZE_SDK_ENDPOINT
  const apiKey = publicConfig.BRAZE_WEB_API_KEY
  const brazeSdkEnabled = publicConfig.BRAZE_WEB_SDK_ENABLED

  useEffect(() => {
    if (brazeSdkEnabled == "true" && conditionsMetToTrackUser()) {
      nonProdLogger("Initialising Braze SDK")
      brazeInitialise(sdkEndpoint, apiKey)
    }
  }, [brazeSdkEnabled, sdkEndpoint, apiKey])

  return <></>
}
